import styled from 'styled-components'

export const EditorJsWrapper = styled.div`
	.icon {
		padding: initial;
	}
	.ce-block__content {
		max-width: initial;
	}
	.ce-toolbar__content {
		max-width: initial;
	}
	.tc-table {
		border-left: 1px solid var(--color-border);
	}
	.tc-row {
		display: flex;
		width: 100%;
		.tc-cell {
			white-space: pre-line;
			&:first-child {
				width: 10%;
			}
			&:nth-child(2) {
				width: 20%;
			}
			&:nth-child(3) {
				width: 70%;
			}
		}
	}
	.tc-row:after,
	.tc-add-row:before,
	.tc-add-column {
		width: 0;
	}
	.codex-editor__redactor {
		padding-bottom: 100px !important;
	}
`
